import { prefixClassName } from "@smartrr/shared/components/primitives";
import { StyledComponentPropsWithRef, ThemedStyledFunction } from "styled-components";

export function classNamePrefixer<
  C extends keyof JSX.IntrinsicElements | React.ComponentType<any>,
  T extends object,
  O extends object = {},
  A extends keyof any = never,
  NewA extends Partial<StyledComponentPropsWithRef<C>> & {
    [others: string]: any;
  } = {}
>(className: string): ThemedStyledFunction<C, T, O & NewA, A | keyof A>["attrs"] {
  return (attrs: any) => ({
    ...attrs,
    className: prefixClassName(className),
  });
}
